import React from "react";
import { StyleSheet, Dimensions } from "react-native";
import {
  Box,
  MainButton,
  MainText,
  PressableOpacity,
} from "../../components/common";
import i18n from "@microdoing/shared/i18n";
import theme from "app/Theme/Theme";

const { width } = Dimensions.get("window");

const SignupBottom = ({
  onPressBack,
  onPressNext,
  isRequesting = false,
  testID = "",
}) => {
  return (
    <Box width="100%">
      <MainButton
        testID={testID}
        text={i18n.t("signup-next-button")}
        onPress={onPressNext}
        isLoading={isRequesting}
        color="brand.500"
      />
      <PressableOpacity onPress={onPressBack} style={{ marginBottom: 12 }}>
        <MainText variant="l4-semibold" color="neutral.400" textAlign="center">
          {i18n.t("signup-previous-button")}
        </MainText>
      </PressableOpacity>
    </Box>
  );
};

const styles = StyleSheet.create({
  main: {
    flexDirection: "row",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    paddingBottom: 15,
  },
  loadingView: {
    alignItems: "center",
    justifyContent: "center",
    width: width / 2 - 30,
  },
  buttonLeft: {
    borderWidth: 0,
    borderColor: theme.colors["neutral.400"],
    width: width / 2 - 30,
    borderRadius: 25,
  },
});

SignupBottom.defaultProps = {
  title: "Inscription",
  progress: 0.1,
};

export default SignupBottom;
